import React from 'react'
import GrupoDePagamentoService from '../../app/service/contasAPagar/grupoDePagamentoService'
import HandleErrorService from '../../app/service/handleErrorService'
import ChooseGrupoDePagamentoDialog from './chooseGrupoDePagamentoDialog'
import { MultiSelect } from 'primereact/multiselect'
import ConstantsUtil from '../../context/constantsUtil'
import TooltipButton from '../tooltipButton'
import { Dropdown } from 'primereact/dropdown'
import EditOrCreateGrupoDePagamentoDialog from './editOrCreateGrupoDePagamentoDialog'

class InputChooseGrupoDePagamento extends React.Component {

    constructor(){
        super()
        this.grupoDePagamentoService = new GrupoDePagamentoService()
    }

    state = {

        grupoDePagamentoList: [],
        chooseGrupoDePagamentoDialogVisible: false,
        loading: false,
        forceUpdateGrupoDePagamentoDialog: false,

        gruposDePagamentoSelectList: [],
        
    }

    componentDidMount(){
        this.searchGrupoDePagamento()
    }

    handleSelectedGrupoDePagamentoChange = () => {
        this.setState({chooseGrupoDePagamentoDialogVisible: false})
        
        if(this.props.doNotForceGrupoDePagamentoDialog)
            this.props.doNotForceGrupoDePagamentoDialog()
    }

    handleChange = (grupoDePagamento) => {
        this.props.handleSelectionGrupoDePagamentoChange(grupoDePagamento)
    }

    searchGrupoDePagamento = () => {
        this.setState({loading: true})
        this.grupoDePagamentoService.search()
        .then(response => {

            let grupoDePagamentoList = response.data
            
            this.setState({grupoDePagamentoList})

            let gruposDePagamentoSelectList = grupoDePagamentoList.map(grupoDePagamento => ({
                label: `${grupoDePagamento.nome}`,
                value: grupoDePagamento.id
            }))
            this.setState({gruposDePagamentoSelectList})

            this.checkById()
            if(this.props.autofocus){
                this.inputClick()
            }
        })
        .catch(error => {
            HandleErrorService.handleError(error)
        })
        .finally(() => {
            this.setState({forceUpdateGrupoDePagamentoDialog: true})
            this.setState({loading: false})
        })
    }

    doneForceUpdate = () => {
        this.setState({forceUpdateGrupoDePagamentoDialog: false})
    }

    checkById = () => {
        if(this.props.searchGrupoDePagamentoById){
            const id = this.props.grupoDePagamentoId
            const grupoDePagamento = this.state.grupoDePagamentoList.find(grupoDePagamento => grupoDePagamento.id === id)
            this.handleChange(grupoDePagamento)
        }
    }

    handleKeyPress = async (e) => {
        if (e.key === "Enter") {
            this.inputClick()
          }
    }

    inputClick = () => {
        this.setState({chooseGrupoDePagamentoDialogVisible: true})
    }

    handleMultiSelectChange = async (event) => {
        // console.log('handleMultiSelectChange: ', event)
        const name = event.target.name
        const value = event.target.value
        await this.setState({ [name]: value })
        // let gruposDePagamentoList = value.map(item => ({id: item}) )
        let gruposDePagamentoList = this.state.grupoDePagamentoList.filter(grupoDePagamento => value.includes(grupoDePagamento.id))
        // console.log("gruposDePagamentoList: ", gruposDePagamentoList)
        this.props.handleSelectionGrupoDePagamentoMultiSelectChange(gruposDePagamentoList)
        // console.log('this.state.selectedTipoDePagamentoIdsSimpleViewMultiSelect: ', this.state.selectedTipoDePagamentoIdsSimpleViewMultiSelect)
    }

    handleGrupoDePagamentoChangeSelectList = (event) => {
        this.setState({selectedGrupoDePagamentoIdSimpleView: event.value})
        let selectedGrupoDePagamento = this.state.grupoDePagamentoList.find(grupoDePagamento => grupoDePagamento.id === event.value);
        this.props.handleSelectionGrupoDePagamentoChange(selectedGrupoDePagamento)
    }

    hideCadastroGrupoDePagamentoDialog = () => {
        this.setState({displayCadastroGrupoDePagamentoDialog: false})
    }

    render(){

        const handleView = () => {
            if(this.props.simpleView){
                return(
                <div className='col-md-12'>

                    <div className='row'>
                        <label style={{ display: 'block' }}>Grupo de Pagamento</label>
                        {renderCadastrarButtonSimpleView()}
                    </div>

                    {handleSelectView()}

                    {renderCreateGrupoDePagamentoDialogSimpleView()}

                </div>
                )
            }

            return(
                <>
                    {renderInput()}
                </>
            )

        }

        const renderCadastrarButtonSimpleView = () => {
            if(this.props.simpleView && this.props.enableCadastrarButtonInSimpleView){
                return (
                    <>
                        <TooltipButton
                            tooltip="Cadastrar Grupo de Pagamento"
                            style={{marginLeft: '15px', maxWidth: '20px', maxHeight: '20px'}}
                            icon="pi pi-plus"
                            onClick = {() => this.setState({displayCadastroGrupoDePagamentoDialog: true})}
                        />
                    </>
                )
            }
        }

        const handleSelectView = () => {
                if(this.props.multiSelect){
                    return(
                        <>
                            {renderMultiSelect()}
                        </>
                    )
                }
                return (
                    <>
                        {renderSelect()}
                    </>
                )
        }

        const renderMultiSelect = () => {
            return(
                <>
                    <div className='row'>
                        <MultiSelect
                            style={{width: '100%'}}
                            display="chip"
                            showClear
                            value={this.state.selectedGrupoDePagamentoIdsSimpleViewMultiSelect}
                            options={this.state.gruposDePagamentoSelectList}
                            name="selectedGrupoDePagamentoIdsSimpleViewMultiSelect"
                            onChange={this.handleMultiSelectChange}
                            optionLabel="label"
                            placeholder='Selecione'
                            filter
                            filterBy="label"
                        />
                    </div>
                </>
            )
        }

        const renderSelect = () => {
            return (
                <>

                    <div className='row'>
                        <Dropdown
                            className={this.props.error ? ConstantsUtil.primereactInputErrorClass : ""}
                            value={this.state.selectedGrupoDePagamentoIdSimpleView}
                            // value={this.props.selectedTipoDePagamentoLabel}
                            options={this.state.gruposDePagamentoSelectList}
                            onChange={this.handleGrupoDePagamentoChangeSelectList}
                            optionLabel="label"
                            filter
                            showClear
                            style={{width: '100%'}}
                            filterBy="label"
                            placeholder="Selecione"
                            emptyMessage=""
                            emptyFilterMessage=""
                        />
                        <small className="p-error">{this.props.error ? "Selecione o Grupo de Pagamento" : ""}</small>
                    </div>

                </>


            )
        }

        const renderCreateGrupoDePagamentoDialogSimpleView = () => {
            return(
            <>
                <EditOrCreateGrupoDePagamentoDialog
                    visible={this.state.displayCadastroGrupoDePagamentoDialog}
                    search={this.searchGrupoDePagamento}
                    hideDialog={this.hideCadastroGrupoDePagamentoDialog}
                    dialogType={ConstantsUtil.tipoDialogGrupoDePagamentoCreateLabel}
                />
            </>
            )
        }

        const renderInvalidFeedbackMessage = () => {
            if(this.props.inputGrupoDePagamentoErrorClass){
                return <div className="invalid-feedback">Selecione o Grupo de Pagamento</div>
            }

            return <></>
        }

        const renderInput = () => {
            return (
                <>
                <label >{this.props.header ? this.props.header : 'Grupo de Pagamento'}</label>
                    <input 
                        type="text"
                        className={"form-control " + this.props.inputGrupoDePagamentoErrorClass}
                        readOnly
                        value = {this.props.selectedGrupoDePagamentoLabel}
                        name="selectedGrupoDePagamentoLabel"
                        id="selectedGrupoDePagamento"
                        placeholder="Nenhum Grupo de Pagamento Selecionado..."
                        onClick={this.inputClick}
                        onKeyPress={this.handleKeyPress}
                        disabled={this.props.disabled}
                    />
                    {/* <div className="invalid-feedback">Selecione o Grupo de Pagamento</div> */}
                    {renderInvalidFeedbackMessage()}
                </>
            )
        }

        const renderHTMLFormat = () => {
            if(this.props.noHTMLFormat){
                return (
                    <>
                    {handleView()}
                    </>
                )
            }
            else {
                return (
                    <>
                    <div className="row">
                    <div className="col-md-4">
                    {handleView()}
                    </div>
                    </div>
                    </>
                )
            }
        }

        return(
            <>
            
                {renderHTMLFormat()}
                
                <ChooseGrupoDePagamentoDialog 
                    header="Grupos de Pagamento"
                    visible={this.state.chooseGrupoDePagamentoDialogVisible || this.props.forceShowDialog}
                    list={this.state.grupoDePagamentoList}
                    search={this.searchGrupoDePagamento}
                    hideDialog={this.handleSelectedGrupoDePagamentoChange}
                    handleSelectionGrupoDePagamentoChange={this.handleChange}
                    loading={this.state.loading}
                    forceUpdate={this.state.forceUpdateGrupoDePagamentoDialog}
                    doneForceUpdate={this.doneForceUpdate}
                />

            </>
        )

    }


}

export default InputChooseGrupoDePagamento